import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/google-drive': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M339 314.9l-163.6-282.9h161.2l163.6 282.9h-161.2zM201.5 338.5h310.5l-80.6 141.5h-310.5zM154.1 67.4l82.9 141.4-156.4 271.2-80.6-141.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/google-drive.js
// module id = 865
// module chunks = 0